export default "__VITE_ASSET__Bs2_eSUi__"